(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elora-refined"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  var trigger = event.target.closest('[data-elora-size-guide]');
  if (trigger) {
    var dialog = document.getElementById(trigger.dataset.eloraSizeGuide);
    if (!dialog || dialog.open) return;
    dialog.eloraTrigger = trigger;
    dialog.eloraOverflow = document.body.style.overflow;
    dialog.addEventListener('close', function() {
      document.body.style.overflow = dialog.eloraOverflow;
      if (dialog.eloraTrigger && dialog.eloraTrigger.isConnected) dialog.eloraTrigger.focus({preventScroll:true});
    }, {once:true});
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    return;
  }
  var close = event.target.closest('[data-elora-size-close]');
  if (close) close.closest('dialog').close();
  if (event.target.matches('dialog.elora-size-dialog')) {
    var rect = event.target.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
  }
});
  } catch(e) { console.error(e); }
})();

})();
